import { STORAGE_KEY_PW_FEATURE_FLAGS_OVERRIDE } from '@localstack/constants';

/**
 * Default feature flag values.
 *
 * ⚠️ Intended for test utilities only (e.g. Playwright tests).
 * Do NOT import this directly in application code.
 *
 * Console code should import FEATURE_FLAGS instead, which includes
 * Playwright overrides when running in test environments.
 */
export const DEFAULT_FEATURE_FLAGS = {};

export const getPlaywrightFeatureFlagOverrides = (): Record<string, boolean> => {
  if (typeof window === 'undefined') return {};

  const pwFeatureFlagsOverride = JSON.parse(localStorage.getItem(STORAGE_KEY_PW_FEATURE_FLAGS_OVERRIDE) || '{}');

  return process.env.NODE_ENV !== 'production' ? pwFeatureFlagsOverride : {};
};

/**
 * Final resolved feature flags used by the application.
 *
 * Combines default values with optional Playwright overrides
 * injected via localStorage during end-to-end tests.
 */
export const FEATURE_FLAGS = {
  ...DEFAULT_FEATURE_FLAGS,
  ...getPlaywrightFeatureFlagOverrides(),
};
